<template>
  <template v-if="get_isBookmarkChannel">
    <button class="Wdgt-Channels-Item" :class="get_activeClass">
      <div class="Wdgt-Channels-Item__bookmark">
        <StarIcon :color="'var(--orange-500)'" />
      </div>
      <span class="Wdgt-Channels-Item__name">{{ get_channel.name }}</span>
      <CloseCross class="Wdgt-Channels-Item__cross" v-if="get_isActive"/>
    </button>
  </template>
  <template v-else-if="get_isPodcastsChannel">
    <button class="Wdgt-Channels-Item" :class="get_activeClass">
      <div class="Wdgt-Channels-Item__podcast">
        <img class="Wdgt-Channels-Item__zipper-img" :src="ZIPPER_ICON" width="15px" height="15px" />
      </div>
      <span class="Wdgt-Channels-Item__name">{{ get_channel.name }}</span>
      <CloseCross class="Wdgt-Channels-Item__cross" v-if="get_isActive"/>
    </button>
  </template>
  <template v-else-if="get_isAdminChannel">
    <button class="Wdgt-Channels-Item" :class="get_activeClass">
      <div class="Wdgt-Channels-Item__wrench">
        <WrenchIcon />
      </div>
      <span class="Wdgt-Channels-Item__name">{{ get_channel.name }}</span>
      <CloseCross class="Wdgt-Channels-Item__cross" v-if="get_isActive"/>
    </button>
  </template>
  <template v-else-if="get_isUsualChannel">
    <button class="Wdgt-Channels-Item" :class="get_activeClass">
      <AvatarImage class="Wdgt-Channels-Item__img" :size="24" :src="get_channel.logo" :alt="get_channel.name" />
      <span class="Wdgt-Channels-Item__name">{{ get_channel.name }}</span>
      <CloseCross class="Wdgt-Channels-Item__cross" v-if="get_isActive"/>
    </button>
  </template>
  
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from "vuex";
  import { Props } from './scripts/props.js';
  //----------------------
  import StarIcon from '@svg/Star.vue';
  import WrenchIcon from '@svg/WrenchIcon.vue';
  import AvatarImage from '@ui/Images/AvatarImage/AvatarImage.vue';
  import CloseCross from '@ui/Cross/CloseCross.vue';
  //----------------------
  const store = useStore();
  const props = defineProps(Props());
  //----------------------
  const ID = props.idChannel;
  const ZIPPER_ICON = require('@shared/images/smiles/zipper.png');
  //----------------------
  //Включен ли режим добавления каналов
  const get_isActiveEditChannelMode = computed(() => store.state.ContentSystem.isEditChannels);
  //Получить объект канала
  const get_channel = computed(() => store.state.ContentSystem.channelsList[ID]);
  //Этот канал активен
  const get_isActive = computed(() => {
    if(get_isActiveEditChannelMode.value){
      return get_hasPostTheChannel.value;
    }else{
      return ID === store.state.ContentSystem.idChannelActive;
    }
  });
  //Использовать класс модификатор
  const get_activeClass = computed(() => get_isActive.value ? 'Wdgt-Channels-Item--active' : '');
  //Этот канал является подкастами
  const get_isPodcastsChannel = computed(() => get_channel.value.isPodcast && !get_isActiveEditChannelMode.value)
  //Этот канал является избранным
  const get_isBookmarkChannel = computed(() => get_channel.value.isBookmark && !get_isActiveEditChannelMode.value);
  //Этот канал является администрированием
  const get_isAdminChannel = computed(() => get_channel.value.isAdmin && !get_isActiveEditChannelMode.value);
  //Этот канал не является захардкоженным
  const get_isUsualChannel = computed(() => !get_channel.value.isBookmark && !get_channel.value.isAdmin);
  //Получть id поста, в котором будет изменяться список каналов
  const get_editPostId = computed(() => parseInt(store.state.ContentSystem.idEditPostChannels));
  //Получить пост, в котором будет изменен список каналов
  const get_post = computed(() => store.state.ContentSystem.Alpha.list[get_editPostId.value]);
  //Содержит ли пост этот канал
  const get_hasPostTheChannel = computed(() => get_post.value.channels?.some(item => parseInt(item.id) === ID));
</script>

<style lang="scss">
  @import "./styles/_styles";
</style>